import { MedicalTechnologyConfig } from '@app/icare/entities/medicalTechnology/config'
import { patientMedicalTechnologyQueries } from '@app/icare/entities/medicalTechnology/queries/patientMedicalTechnologyQueries'
import { PatientMedicalTechnologyEditDrawer } from '@app/icare/entities/patient/edits/PatientMedicalTechnologyEditDrawer'
import { patientFindingsQueryOptions } from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import type { PatientMedicalTechnologyRelation } from '@app/icare/entities/patient/schema/PatientMedicalTechnology'
import { RelationTabs } from '@app/icare/routes/_app/patienten/$id/_edit/-components/RelationTabs'
import { isActivePatientRelation } from '@app/icare/shared/api'
import { t } from '@lingui/core/macro'
import { entityParams } from '@pkg/db/utils'
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useRelationCommitNavigation } from '../-components/useRelationCommitNavigation'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_medicalTechnology/medizintechnikversorger')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(patientMedicalTechnologyQueries.forTabs(params.id)),
      queryClient.ensureQueryData(patientFindingsQueryOptions(params.id)),
    ]),
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const { data: relations = [] } = useSuspenseQuery(patientMedicalTechnologyQueries.forTabs(id))
  const { data: findings = [] } = useQuery(patientFindingsQueryOptions(id))
  const { data: totalCount } = useQuery(patientMedicalTechnologyQueries.totalCount(id))
  const navigate = Route.useNavigate()

  const handleAfterCommit = useRelationCommitNavigation<PatientMedicalTechnologyRelation>({
    isInactive: relation => !isActivePatientRelation(relation),
    onCreateNavigate: relation =>
      navigate({
        to: '/patienten/$id/medizintechnikversorger/$relation',
        params: { id, relation: relation.id },
      }),
    onInactiveEditNavigate: () => navigate({ to: '.', replace: true }),
  })
  return (
    <RelationTabs
      relations={relations}
      relationTotalCount={totalCount}
      basePath={`/patienten/${id}/medizintechnikversorger`}
      findings={findings}
      findingsGroup={undefined}
      getLabel={item => MedicalTechnologyConfig.format.primary(item.to) ?? t`Medizintechnikversorger`}
      onAdd={params =>
        void PatientMedicalTechnologyEditDrawer.show({ patientId: id, onAfterCommit: handleAfterCommit, ...params })
      }
      entity="medicalTechnology"
    />
  )
}
